import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { sendGoogleAdsConversion } from '../utils/googleAds';

export default function AuthConversionTracker() {
  const { isAuthenticated, user } = useAuth();
  useEffect(() => {
    if (!isAuthenticated || sessionStorage.getItem('marketscan_pending_google_signup') !== 'true') return;
    const email = user?.email || user?.profile?.email || '';
    sendGoogleAdsConversion('signup', { dedupeKey: `oauth-signup:${email || 'completed'}`, email });
    sessionStorage.removeItem('marketscan_pending_google_signup');
  }, [isAuthenticated, user]);
  return null;
}
